<template>
  <div class="launcher" v-if="app != null && app.data != null">
    <div class="about" id="about-content">
      <!-- <div @click="app.closeAbout()" id="boule">=</div> -->
      <h1>à propos</h1>
      <img id="line" class="line" src="line.png" />
      <div id="close-about"><img src="arrows/white-cross.png" /></div>

      <div id="about-selector">
        <h2>Vous aimez les musées de Troyes ?</h2>
        <p>Cette application a été rendue possible grâce aux</p>
        <img src="adm_logo.png" />
        <p>
          Envie de devenir mécène et de participer à des moments privilégiés?
        </p>
        <p>Venez rejoindre l'association !</p>
        <a
          href="https://www.ffsam.org/sam/amis-des-musees-dart-et-dhistoire-de-troyes/"
        >
          <button>Renseignements et adhésion</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsVue",
  props: {
    app: Object,
  },
  components: {},
};
</script>
